import React from 'react';
import Select from '@material-ui/core/Select';
// import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types';

export default function MetaPickList({
  name,
  value,
  options,
  handleSelect,
  className,
  allowMultiple,
  disableUnderline,
  fullWidth,
}) {
  return (
    <FormControl
      className={className}
      fullWidth={fullWidth}
    >
      <Select
        MenuProps={{
          // MUI multiselect has a bug
          getContentAnchorEl: () => null, // See https://github.com/mui-org/material-ui/issues/19245#issuecomment-620488016
          top: '480px',
        }}
        multiple={allowMultiple}
        value={value}
        name={name}
        autoWidth
        onChange={e => handleSelect(e.target.value)}
        disableUnderline={disableUnderline}
      >
        {allowMultiple && (
        <MenuItem value={null}>
          <em>All</em>
        </MenuItem>)}
        {options.map(o => (
          <MenuItem key={`${o.id}_meta_pl`} value={o.id}>
            {o.prompt}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

MetaPickList.propTypes = {
  value: PropTypes.array,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleSelect: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  allowMultiple: PropTypes.bool,
  disableUnderline: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

MetaPickList.defaultProps = {
  value: [],
  className: '',
  allowMultiple: true,
  disableUnderline: false,
  fullWidth: false,
};
